const ConnectedModuleCardConstants = {
    MANAGE_TENANTS_SPINNER_HEIGHT: '408px',
    FIND_TENANTS_MODULE_MIN_HEIGHT_XL: '498px',
};

export default ConnectedModuleCardConstants;
